import { createAction, props } from "@ngrx/store";
import { MaquinaMovil } from "./entity-maquinas-moviles.model";

export const entityMaquinaMovilLoadRequest = createAction(
  '[ENTITYMAQUINAMOVIL] Load Request'
);

export const entityMaquinaMovilLoadFailure = createAction(
  '[ENTITYMAQUINAMOVIL] Load Failure',
  props<{ error: Error }>()
);

export const entityMaquinaMovilLoadSuccess = createAction(
  '[ENTITYMAQUINAMOVIL] Load Success',
  props<{ items: MaquinaMovil[] }>()
);

export const entityMaquinaMovilAddRequest = createAction(
  '[ENTITYMAQUINAMOVIL] Add Request',
  props<{ item: MaquinaMovil }>()
);

export const entityMaquinaMovilAddFailure = createAction(
  '[ENTITYMAQUINAMOVIL] Add Failure',
  props<{ error: Error }>()
);

export const entityMaquinaMovilAddSuccess = createAction(
  '[ENTITYMAQUINAMOVIL] Add Success',
  props<{ item: MaquinaMovil }>()
);

export const entityMaquinaMovilDeleteRequest = createAction(
  '[ENTITYMAQUINAMOVIL] Delete Request',
  props<{ item: MaquinaMovil }>()
);

export const entityMaquinaMovilDeleteFailure = createAction(
  '[ENTITYMAQUINAMOVIL] Delete Failure',
  props<{ error: Error }>()
);

export const entityMaquinaMovilDeleteSuccess = createAction(
  '[ENTITYMAQUINAMOVIL] Delete Success',
  props<{ item: MaquinaMovil }>()
);

export const entityMaquinaMovilUpdateRequest = createAction(
  '[ENTITYMAQUINAMOVIL] Update Request',
  props<{ item: MaquinaMovil }>()
);

export const entityMaquinaMovilUpdateFailure = createAction(
  '[ENTITYMAQUINAMOVIL] Update Failure',
  props<{ error: Error }>()
);

export const entityMaquinaMovilUpdateSuccess = createAction(
  '[ENTITYMAQUINAMOVIL] Update Success',
  props<{ item: MaquinaMovil }>()
);
